import * as React from "react";
import { Redirect } from "react-router-dom";

const AboutPage: React.FunctionComponent = () => {
    return <Redirect to="/home" />;
};

export default AboutPage;
